import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';

import { useShowToast } from '../../hooks/fsHooks';
import styles from './CopyCode.module.scss';

export function CopyCode({ flagsValue }: { flagsValue: string }) {
  const showToast = useShowToast();
  const { t } = useTranslation();
  const theme = useTheme();
  const primary = theme.dec.color.brand.default.bg.norm;
  const copyToClipboard = () => {
    navigator.clipboard.writeText(flagsValue);
    showToast({ type: 'SUCCESS', text: t('Flag value has been copied to clipboard !') });
  };
  return (
    <div className={styles.copyCode} onClick={copyToClipboard}>
      <svg width="25" height="25" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="Size=16px">
          <path
            id="Stroke 1 (Stroke)"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.44491 9.8882C3.99611 10.4394 4.94969 10.7333 6.66657 10.7333C8.38345 10.7333 9.33703 10.4394 9.88823 9.8882C10.4394 9.33698 10.7332 8.38347 10.7332 6.66692C10.7332 4.9501 10.4394 3.99646 9.88821 3.44518C9.33701 2.89391 8.38345 2.6 6.66657 2.6C4.94969 2.6 3.99613 2.89391 3.44493 3.44518C2.89372 3.99646 2.5999 4.9501 2.5999 6.66692C2.5999 8.38347 2.89371 9.33698 3.44491 9.8882ZM2.59637 10.7367C1.6893 9.82962 1.3999 8.44993 1.3999 6.66692C1.3999 4.88367 1.6893 3.50386 2.59635 2.5967C3.50343 1.68952 4.8832 1.4 6.66657 1.4C8.44994 1.4 9.82971 1.68952 10.7368 2.5967C11.6438 3.50386 11.9332 4.88367 11.9332 6.66692C11.9332 8.44993 11.6438 9.82962 10.7368 10.7367C9.8297 11.6438 8.44994 11.9333 6.66657 11.9333C4.8832 11.9333 3.50344 11.6438 2.59637 10.7367Z"
            fill={primary}
          />
          <path
            id="Stroke 2 (Stroke)"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.10992 13.3854C6.23359 13.078 6.58307 12.929 6.8905 13.0527C7.46544 13.284 8.25333 13.4 9.33321 13.4C11.0501 13.4 12.0037 13.1061 12.5549 12.5549C13.1061 12.0036 13.3999 11.0501 13.3999 9.33358C13.3999 8.25359 13.2839 7.46561 13.0526 6.89061C12.9289 6.58319 13.0778 6.23371 13.3853 6.11002C13.6927 5.98634 14.0422 6.1353 14.1658 6.44272C14.4804 7.22449 14.5999 8.18953 14.5999 9.33358C14.5999 11.1166 14.3105 12.4963 13.4034 13.4034C12.4963 14.3105 11.1166 14.6 9.33321 14.6C8.18924 14.6 7.22432 14.4805 6.44263 14.166C6.13521 14.0423 5.98625 13.6929 6.10992 13.3854Z"
            fill={primary}
          />
        </g>
      </svg>
    </div>
  );
}
